/**
 * Services Configuration
 * 
 * Defines all service offerings for the company.
 */

export const SERVICES = [
  {
    id: 'ai-automation',
    icon: '🧠',
    title: 'AI & Automation',
    shortDescription: 'Leverage cutting-edge AI and machine learning to automate processes and unlock data-driven insights.',
    fullDescription: 'Leverage cutting-edge AI and machine learning to automate processes and unlock data-driven insights that transform your business operations.',
    features: [
      'Machine Learning Solutions',
      'Process Automation',
      'Predictive Analytics',
      'Natural Language Processing',
    ],
  },
  {
    id: 'mobile-development',
    icon: '📱',
    title: 'Mobile App Development',
    shortDescription: 'Native and cross-platform mobile applications that deliver exceptional user experiences.',
    fullDescription: 'Native and cross-platform mobile applications that deliver exceptional user experiences on iOS and Android, built for performance and scalability.',
    features: [
      'iOS & Android Development',
      'Cross-Platform Solutions',
      'UI/UX Design',
      'App Store Optimisation',
    ],
  },
  {
    id: 'cloud-devops',
    icon: '☁️',
    title: 'Cloud & DevOps Solutions',
    shortDescription: 'Scalable cloud infrastructure and streamlined DevOps pipelines.',
    fullDescription: 'Scalable cloud infrastructure and streamlined DevOps pipelines for faster, more reliable deployments that keep your business agile and competitive.',
    features: [
      'Cloud Migration',
      'Infrastructure as Code',
      'CI/CD Pipelines',
      'Kubernetes & Containerisation',
    ],
  },
  {
    id: 'business-intelligence',
    icon: '📊',
    title: 'Business Intelligence & Data',
    shortDescription: 'Transform raw data into actionable insights with advanced analytics.',
    fullDescription: 'Transform raw data into actionable insights with advanced analytics, intuitive dashboards, and data strategies that drive informed decisions.',
    features: [
      'Data Analytics',
      'Dashboard Development',
      'Data Warehousing',
      'Reporting Solutions',
    ],
  },
];
